import "./PrimaryNav.scss";
import Typography from "../Typography";
import FinkraftLogo from "static/images/FinLogo.png";
import {
  LeftOutlined,
  UserAddOutlined,
  SettingOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import { Menu, MenuProps } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { colorPicker } from "app/utils/color.helper";
type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

export default function SubMenu(props: any) {
  const [activeMenu, setActiveMenu] = useState("");
  const [menuStack, setMenuStack] = useState<any[]>(
    props.menuItems ? [props.menuItems] : []
  );
  const navigate = useNavigate();
  const onClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
    navigate(e.key);
  };

  useEffect(() => {
    if (props.menuItems) {
      setMenuStack([props.menuItems]);
    }
  }, [props.menuItems]);

  const currentMenu = menuStack.length > 0 ? menuStack[menuStack.length - 1] : null;

  return (
    <div className="PrimaryNavSubMenu">
      <div className="WorkspaceInfoContainer">
        
      <Typography
          style={{ marginBottom: 16, marginTop: 16, color: colorPicker("primary.700"), width: "100%"}}
        >
          {(currentMenu && currentMenu.title) ||
            (props.menuItems && props.menuItems.title) ||
            "Menu"}
        </Typography>

        <div className="LeftContent">
          {menuStack.length > 1 && (
            <div
              className="BackAction"
              onClick={() => {
                setMenuStack(menuStack.slice(0, -1));
              }}
            >
              <LeftOutlined />
            </div>
          )}
        </div>
        <div className="CollapseAction" onClick={props.onClose}>
          <LeftOutlined />
        </div>
      </div>
      <div className="MenuContainer">
        {/* <Typography
          style={{ marginBottom: 16, color: colorPicker("primary.700") }}
        >
          {(currentMenu && currentMenu.title) ||
            (props.menuItems && props.menuItems.title) ||
            "Menu"}
        </Typography> */}
        {currentMenu &&
          currentMenu.subMenus &&
          currentMenu.subMenus.map((menu: any, key: any) => {
            return (
              <div
                className={
                  "MenuItem " + (activeMenu === menu.route ? " active" : "")
                }
                key={key}
                onClick={() => {
                  if (menu.subMenus && menu.subMenus.length > 0) {
                    setMenuStack([...menuStack, menu]);
                  } else {
                    if (menu.route) {
                      navigate(menu.route);
                      setActiveMenu(menu.route);
                    }
                  }
                }}
              >
                {props.iconMap[menu.icon]}{" "}
                <Typography style={{ marginLeft: 6 }} variant="caption">
                  {menu.title}
                </Typography>
              </div>
            );
          })}
      </div>
    </div>
  );
}
